import 'bootstrap/dist/css/bootstrap.css';
import { useState } from 'react';
import Spinner from '../../shared/spinner';
import ScrollToTopButton from '../../shared/scrollToTopButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import InputMask from 'react-input-mask';
import CustomAlert from '../../shared/customAlert';
import ProcessadoraCartaoService from '../../services/processadoraCartaoService';

// Interfaces para tipos
interface RastreamentoCartaoProcessadoraCartao {
  shippingCompany: string;
  zipCode: string;
  numOrg: string;
  cityHome: string;
  returnDescription: string;
  customerName: string;
  addressHomeNumber: string;
  addressHome: string;
  addressHomeComplement: string | null;
  returnCode: string;
  numAr: string;
  dtRef: string;
  cityCodeWork: string;
  district: string;
  embossName: string;
}

interface RastreamentoError {
  returnCode: string;
  returnDescription: string;
}

function ConsultaRastreamentoCartao() {
  const [alert, setAlert] = useState<{ message: string; type: 'success' | 'warning' | 'error' } | null>(null);
  const [loading, setLoading] = useState(false);
  const [numeroProposta, setNumeroProposta] = useState(''); 
  
  const [resultadoSucesso, setResultadoSucesso] = useState<RastreamentoCartaoProcessadoraCartao | null>(null);
  const [resultadoErro, setResultadoErro] = useState<RastreamentoError | null>(null);
  const [exibeResultado, setExibeResultado] = useState(false);

  const processadoraCartaoService = new ProcessadoraCartaoService();

  const consultarRastreamento = async () => {

    const requestBody = { numeroProposta: numeroProposta };

    setLoading(true);
    setResultadoSucesso(null);
    setResultadoErro(null);

    try {

      const response = await processadoraCartaoService.rastreioCartao(requestBody);
      const data: RastreamentoCartaoProcessadoraCartao = response.data;

      setResultadoSucesso(data);
      setAlert({ message: 'Consulta de rastreamento realizada com sucesso!', type: 'success' });
      setExibeResultado(true);
    } catch (err: any) {
      const errorCode = err.response?.data?.returnCode || err.response?.status?.toString() || '500';
      const errorDescription = err.response?.data?.returnDescription || 'Erro desconhecido ao consultar rastreamento.';

      setResultadoErro({ returnCode: errorCode, returnDescription: errorDescription });
      setAlert({ message: `Erro na consulta: ${errorDescription}`, type: 'error' });
      setExibeResultado(true);

      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {alert && <CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />}
      <div className="position-relative m-md-3">
        {loading ? <Spinner loading={loading} /> : (
          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-body">
              <div className="card-header"><strong>Consulta Rastreamento de Cartão</strong></div>

              {/* Campos de entrada */}
              <div className="row" style={{ marginTop: '15px' }}>
                <div className="col-md-4"> 
                  <div className="form-group">
                    <label>Número da Proposta <span style={{ color: 'red' }}>*</span></label>
                    <InputMask
                      mask="9999"
                      type="text"
                      className="form-control form-control-sm brds"
                      value={numeroProposta}
                      onChange={(e) => setNumeroProposta(e.target.value.replace(/_/g, ''))}
                      placeholder="Ex: 7777"
                    />
                  </div>
                </div>
              </div>

              {/* Botão de consulta */}
              <div className="row" style={{ marginTop: '15px' }}>
                <div className="col-md-3">
                  <button
                    className="input-group-btn"
                    id="App-button-cor-principal"
                    style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid LightGrey', borderRadius: '5px', height: '50px', minWidth: '50px' }}
                    onClick={consultarRastreamento}
                  >
                    <FontAwesomeIcon icon={faSearch} style={{ color: 'White', fontSize: 'larger', marginTop: '5px' }} />
                    <strong style={{ color: 'White', marginLeft: '5px', fontSize: 'larger' }}> Consultar Rastreamento</strong>
                  </button>
                </div>
              </div>

              {/* Exibição de sucesso */}
              {exibeResultado && resultadoSucesso && (
                <>
                  <hr style={{ marginTop: '20px', marginBottom: '20px' }} />
                  <h4><strong>Dados de Rastreamento (Sucesso)</strong></h4>
                  <div className="row" style={{ marginTop: '10px' }}>
                    <div className="col-md-4">
                      <label>Parceiro de Postagem:</label>
                      <input type="text" readOnly className="form-control form-control-sm brds" value={resultadoSucesso.shippingCompany} style={{ backgroundColor: 'LightGrey' }} />
                    </div>
                    <div className="col-md-2">
                      <label>CEP:</label>
                      <input type="text" readOnly className="form-control form-control-sm brds" value={resultadoSucesso.zipCode} style={{ backgroundColor: 'LightGrey' }} />
                    </div>
                    <div className="col-md-2">
                      <label>Cidade:</label>
                      <input type="text" readOnly className="form-control form-control-sm brds" value={resultadoSucesso.cityHome} style={{ backgroundColor: 'LightGrey' }} />
                    </div>
                    <div className="col-md-4">
                      <label>Nome do Cliente (Emboss):</label>
                      <input type="text" readOnly className="form-control form-control-sm brds" value={resultadoSucesso.embossName} style={{ backgroundColor: 'LightGrey' }} />
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: '10px' }}>
                    <div className="col-md-6">
                      <label>Endereço:</label>
                      <input type="text" readOnly className="form-control form-control-sm brds" value={`${resultadoSucesso.addressHome}, ${resultadoSucesso.addressHomeNumber} ${resultadoSucesso.addressHomeComplement ? `- ${resultadoSucesso.addressHomeComplement}` : ''}`} style={{ backgroundColor: 'LightGrey' }} />
                    </div>
                    <div className="col-md-3">
                      <label>Data de Referência:</label>
                      <input type="text" readOnly className="form-control form-control-sm brds" value={resultadoSucesso.dtRef} style={{ backgroundColor: 'LightGrey' }} />
                    </div>
                    <div className="col-md-3">
                      <label>Descrição do Retorno:</label>
                      <input type="text" readOnly className="form-control form-control-sm brds" value={resultadoSucesso.returnDescription} style={{ backgroundColor: 'LightGrey' }} />
                    </div>
                  </div>
                </>
              )}

              {/* Exibição de erro */}
              {exibeResultado && resultadoErro && (
                <>
                  <hr style={{ marginTop: '20px', marginBottom: '20px' }} />
                  <h4><strong>Status da Consulta (Erro)</strong></h4>
                  <div className="row" style={{ marginTop: '10px' }}>
                    <div className="col-md-2">
                      <label>Código de Retorno:</label>
                      <input type="text" readOnly className="form-control form-control-sm brds" value={resultadoErro.returnCode} style={{ backgroundColor: '#f8d7da', color: '#721c24' }} />
                    </div>
                    <div className="col-md-10">
                      <label>Descrição:</label>
                      <input type="text" readOnly className="form-control form-control-sm brds" value={resultadoErro.returnDescription} style={{ backgroundColor: '#f8d7da', color: '#721c24' }} />
                    </div>
                  </div>
                </>
              )}

            </div>
          </div>
        )}
      </div>
      <ScrollToTopButton />
    </>
  );
}

export default ConsultaRastreamentoCartao;